(function () {
  if (window.__czCovalie) return;
  window.__czCovalie = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Kopfzeile: Burger + Ausblenden beim Scrollen ---------- */
  function initHeader() {
    document.querySelectorAll('.n-burger').forEach(function (btn) {
      if (btn.dataset.czInit) return;
      btn.dataset.czInit = '1';
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (nav) nav.classList.toggle('est-ouvert', !open);
      });
    });
    var sec = document.querySelector('.nola .n-entete');
    sec = sec && sec.closest('.shopify-section');
    if (!sec || sec.dataset.czInit) return;
    sec.dataset.czInit = '1';
    var last = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var nav = sec.querySelector('.n-nav.est-ouvert');
      if (!nav) sec.classList.toggle('n-entete--cachee', y > last && y > 120);
      last = y;
    }, { passive: true });
  }

  /* ---------- Pack-Auswahl ---------- */
  function lotData(lot) {
    var el = lot.querySelector('[data-cz-lot-data]');
    try { return JSON.parse(el.textContent); } catch (e) { return { couleurs: [], variants: [] }; }
  }

  function closeLists(except) {
    document.querySelectorAll('.cz-lot__couleur-liste').forEach(function (l) {
      if (l !== except) {
        l.hidden = true;
        var b = l.parentNode.querySelector('.cz-lot__couleur-bouton');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function setColour(btn, data, idx) {
    var c = data.couleurs[idx];
    if (!c) return;
    btn.dataset.couleur = String(idx);
    var img = btn.querySelector('.cz-lot__vignette');
    if (img) img.src = c.image;
    btn.querySelectorAll('.cz-lot__couleur-noms > span').forEach(function (s, i) {
      s.classList.toggle('est-choisi', i === idx);
    });
    var label = btn.getAttribute('aria-label') || '';
    btn.setAttribute('aria-label', label.split(',')[0] + ', ' + c.nom);
  }

  function openList(btn, data) {
    var wrap = btn.parentNode;
    var list = wrap.querySelector('.cz-lot__couleur-liste');
    if (!list) {
      list = document.createElement('div');
      list.className = 'cz-lot__couleur-liste';
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      data.couleurs.forEach(function (c, i) {
        var o = document.createElement('button');
        o.type = 'button';
        o.className = 'cz-lot__couleur-choix';
        o.setAttribute('role', 'option');
        o.innerHTML = '<img class="cz-lot__couleur-image" alt="" width="32" height="32"><span class="cz-lot__couleur-nom"></span><span class="cz-lot__couleur-coche"></span>';
        o.querySelector('img').src = c.image;
        o.querySelector('.cz-lot__couleur-nom').textContent = c.nom;
        o.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setColour(btn, data, i);
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        });
        list.appendChild(o);
      });
      wrap.appendChild(list);
    }
    var cur = parseInt(btn.dataset.couleur || '0', 10);
    list.querySelectorAll('.cz-lot__couleur-choix').forEach(function (o, i) {
      o.setAttribute('aria-selected', i === cur ? 'true' : 'false');
    });
    closeLists(list);
    var willOpen = list.hidden;
    list.hidden = !willOpen;
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function selectedLot() {
    var lot = document.querySelector('[data-cz-lot]');
    if (!lot) return null;
    var input = lot.querySelector('input[name="cz-lot"]:checked') || lot.querySelector('input[name="cz-lot"]');
    return input ? input.closest('.cz-lot__choix') : null;
  }

  function syncBar() {
    var choix = selectedLot();
    if (!choix) return;
    document.querySelectorAll('[data-hy-collant]').forEach(function (bar) {
      var n = bar.querySelector('[data-hy-nom]');
      var p = bar.querySelector('[data-hy-prix]');
      var b = bar.querySelector('[data-hy-barre]');
      if (n) n.textContent = choix.dataset.nom || '';
      if (p) p.textContent = choix.dataset.prixLot || '';
      if (b) b.textContent = choix.dataset.barreLot || '';
    });
  }

  function buildItems() {
    var lot = document.querySelector('[data-cz-lot]');
    var choix = selectedLot();
    if (!lot || !choix) return null;
    var data = lotData(lot);
    var counts = {};
    var order = [];
    choix.querySelectorAll('.cz-lot__article').forEach(function (art) {
      var btn = art.querySelector('.cz-lot__couleur-bouton');
      var sel = art.querySelector('select');
      var c = data.couleurs[parseInt((btn && btn.dataset.couleur) || '0', 10)];
      var size = sel ? sel.value : null;
      var v = data.variants.filter(function (x) { return x.o1 === (c && c.nom) && (size === null || x.o2 === size); })[0];
      if (!v) return;
      if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
      counts[v.id] += 1;
    });
    return order.map(function (id) { return { id: id, quantity: counts[id] }; });
  }

  var busy = false;
  function buy(btn) {
    if (busy) return;
    var items = buildItems();
    if (!items || !items.length) return;
    busy = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function () {
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
        alert('Leider ist ein Fehler aufgetreten. Bitte versuche es erneut.');
      });
  }

  function initLot() {
    var lot = document.querySelector('[data-cz-lot]');
    if (!lot || lot.dataset.czInit) return;
    lot.dataset.czInit = '1';
    var data = lotData(lot);
    lot.addEventListener('click', function (e) {
      var btn = e.target.closest('.cz-lot__couleur-bouton');
      if (btn) {
        e.preventDefault();
        var choix = btn.closest('.cz-lot__choix');
        var radio = choix && choix.querySelector('input[type="radio"]');
        if (radio && !radio.checked) { radio.checked = true; syncBar(); }
        openList(btn, data);
      }
    });
    lot.addEventListener('change', function (e) {
      if (e.target.name === 'cz-lot') { syncBar(); return; }
      var choix = e.target.closest('.cz-lot__choix');
      var radio = choix && choix.querySelector('input[type="radio"]');
      if (radio && !radio.checked) { radio.checked = true; syncBar(); }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cz-lot__couleur')) closeLists(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLists(null);
    });
    syncBar();

    document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        buy(form.querySelector('[type="submit"]'));
      }, true);
    });
  }

  /* ---------- Klebende Kaufleiste ---------- */
  function initBar() {
    document.querySelectorAll('[data-hy-collant]').forEach(function (bar) {
      if (bar.dataset.czInit) return;
      bar.dataset.czInit = '1';
      var seuil = parseInt(bar.dataset.seuil || '600', 10);
      var atc = document.querySelector('product-form [type="submit"]');
      var atcVisible = false;
      function update() {
        var show = window.scrollY > seuil && !atcVisible;
        bar.classList.toggle('est-visible', show);
        if (show) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
        else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
      }
      if (atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; update(); }).observe(atc);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
      var b = bar.querySelector('[data-hy-collant-achat]');
      if (b) b.addEventListener('click', function () { buy(b); });
    });
  }

  /* ---------- Video: abspielen, sobald sichtbar ---------- */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-cz-video]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.preload = 'auto'; v.play && v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { if (!v.dataset.czInit) { v.dataset.czInit = '1'; io.observe(v); } });
  }

  function init() { initHeader(); initLot(); initBar(); initVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
